(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("moment"), require("window[\"moment-biz\"]"));
	else if(typeof define === 'function' && define.amd)
		define(["moment", "window[\"moment-biz\"]"], factory);
	else if(typeof exports === 'object')
		exports["moment-biz-locale-en-US"] = factory(require("moment"), require("window[\"moment-biz\"]"));
	else
		root["moment-biz-locale-en-US"] = factory(root["moment"], root["window[\"moment-biz\"]"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 